import {reactFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {UpdateIssuesBulk} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'

export type UpdateIssueAssigneesBulkRequest = {
  ids: string[]
  applyAssigneeIds?: string[]
  removeAssigneeIds?: string[]
}

export type UpdateIssueAssigneesBulkResponse = GraphQLResponse<UpdateIssuesBulkMutation>

export async function apiUpdateIssueAssigneesBulk(
  request: UpdateIssueAssigneesBulkRequest,
): Promise<UpdateIssueAssigneesBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {ids: request.ids, queryId: UpdateIssuesBulk}

  if (request.applyAssigneeIds && request.applyAssigneeIds.length > 0) {
    body['applyAssigneeIds'] = request.applyAssigneeIds
  }

  if (request.removeAssigneeIds && request.removeAssigneeIds.length > 0) {
    body['removeAssigneeIds'] = request.removeAssigneeIds
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await reactFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueAssigneesBulkResponse>
}
